import styled from 'styled-components';
import { backgroundGradient } from '../../../commonStyles/backgroundGradient';
import colors from '../../../helpers/colors';
import fonts from '../../../helpers/fonts';
import mediaQuery from '../../../helpers/mediaQuery';
import spacing from '../../../helpers/spacing';
import { Grid, GridItem } from '../../Grid';
import Image from '../../Image';

export const MainImage = styled(Image)`
  margin-top: ${spacing(4)};

  max-height: 200px;

  ${mediaQuery.tabletPortrait`
    margin-top: ${spacing(3)};
    max-height: 354px;
  `}

  ${mediaQuery.tabletLandscape`
    margin: 0;
    max-height: 544px;
  `}
`;

export const AnimationWrapper = styled.div`
  margin-top: ${spacing(4)};

  ${mediaQuery.tabletPortrait`
    margin-top: ${spacing(3)};
  `}

  ${mediaQuery.tabletLandscape`
    margin: 0;
  `}
`;

export const ImageWrapper = styled.div`
  ${backgroundGradient};

  /* Increase the ImageWrapper box size so that the gradient covers a larger area and has the correct center

    Adding 33% (or 50%) width to the left causes the gradient center to be shifted left by 16.5% (or 25%) of the original width  
    Adding extra spacing to the top and bottom allows the gradient to extend slightly into the text, but not so much that
    the text fails accessibility tests. This extra top and bottom spacing is arbitrarily handpicked.
   */
  margin: ${spacing(-8)} 0 ${spacing(-8)} -33%;
  padding: ${spacing(8)} 0 ${spacing(8)} 33%;

  ${mediaQuery.tabletLandscape`
    /* There is no text above or below the image, so we can extend it further */
    margin: -50% 0 -50% -50%; 
    padding: 50% 0 50% 50%;
  `}
`;

export const HeroGrid = styled(Grid)<{ containsMarketingPromo: boolean }>`
  padding-top: ${spacing(4)};
  padding-bottom: ${({ containsMarketingPromo }) =>
    containsMarketingPromo ? spacing(7) : spacing(2)};
  flex-direction: column-reverse;

  ${mediaQuery.tabletLandscape`
    padding: ${spacing(8)} 0 0;
    flex-direction: row;
  `}
`;

export const HeadingGridItem = styled(GridItem)`
  display: flex;
`;

export const HeadingWrapper = styled.h1`
  z-index: 0;
  ${fonts.headingLarge}
  & {
    color: ${colors.neutral08};
  }

  margin: 0;

  ${mediaQuery.tabletLandscape`
    margin: auto 0;
  `}
`;

export const HeroContainer = styled.div<{ containsMarketingPromo: boolean }>`
  position: relative;

  margin-bottom: ${({ containsMarketingPromo }) =>
    containsMarketingPromo ? spacing(14) : spacing(6)};

  ${mediaQuery.tabletPortrait`
    margin-bottom: ${spacing(6)};
  `}

  ${mediaQuery.tabletLandscape`
    margin-bottom: ${spacing(8)};
  `}
`;
